// src/pages/ReleaseNotes.js
import React from 'react';
import Navbar from './Navbar';

const ReleaseNotes = () => {

  return (
    <div style={{ height: '100vh' }}>
      <Navbar />
      <h2 style={{ textAlign: 'center' }}>Release Notes</h2>
      <iframe
        src='pdfs/DiVAReleaseNotes.pdf'
        width="100%"
        height="90%"
        style={{ border: 'none' }}
        title="Release Notes PDF"
      ></iframe>
    </div>
  );
};

export default ReleaseNotes;
